import restClient from "../restClient";

const authConfig = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const unwrapEntity = (item) => {
  if (!item || typeof item !== "object") return null;
  if (item.attributes && typeof item.attributes === "object") {
    return {
      id: item.id,
      documentId: item.documentId ?? item.document_id,
      ...item.attributes,
    };
  }
  return item;
};

export const normalizeTenantMarketingDefault = (payload) => {
  if (!payload) return null;

  if (
    payload.id != null ||
    payload.documentId ||
    payload.cargurus !== undefined ||
    payload.dealertiq_default_service !== undefined
  ) {
    return unwrapEntity(payload);
  }

  const nested =
    payload.data && !Array.isArray(payload.data) ? payload.data : null;
  if (nested?.results || nested?.data) {
    return normalizeTenantMarketingDefault(nested);
  }

  const list = Array.isArray(payload)
    ? payload
    : Array.isArray(payload.results)
      ? payload.results
      : Array.isArray(payload.data)
        ? payload.data
        : nested
          ? [nested]
          : [];

  return unwrapEntity(list[0]) || null;
};

export const getTenantMarketingDefaults = async () => {
  try {
    const response = await restClient.get(
      "tenant-marketing-defaults",
      authConfig()
    );
    return normalizeTenantMarketingDefault(response.data);
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateTenantMarketingDefaults = async (data) => {
  try {
    const response = await restClient.put(
      "tenant-marketing-defaults",
      { data },
      authConfig()
    );
    return normalizeTenantMarketingDefault(response.data) || response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
